/* WebSocket helper for a workspace channel. */
import { getToken } from "./api";

export function openWorkspaceSocket(workspaceId, onMessage) {
  const backend = process.env.REACT_APP_BACKEND_URL;
  if (!backend || !workspaceId) return null;
  const wsUrl =
    backend.replace(/^http/, "ws") +
    `/api/ws/workspace/${workspaceId}?token=${encodeURIComponent(getToken() || "")}`;
  let socket;
  let closed = false;
  let retry = null;

  const connect = () => {
    socket = new WebSocket(wsUrl);
    socket.onmessage = (ev) => {
      try {
        onMessage(JSON.parse(ev.data));
      } catch (_e) {
        // ignore
      }
    };
    socket.onclose = () => {
      if (!closed) retry = setTimeout(connect, 4000);
    };
    socket.onerror = () => {
      try {
        socket.close();
      } catch (_e) {
        // ignore
      }
    };
  };

  connect();
  return () => {
    closed = true;
    if (retry) clearTimeout(retry);
    if (socket && socket.readyState !== WebSocket.CLOSED) {
      try {
        socket.close();
      } catch (_e) {
        // ignore
      }
    }
  };
}
